jQuery(document).on('ready', function(){
	COMMENTS.onReady();
});




const COMMENTS = {
	onReady: function(){
		if ( jQuery('.comments').length < 1 )
			return;




		COMMENTS.getComments();

		jQuery(document).on('click', '.comments-badge', COMMENTS.loadLayer);
		jQuery('.comments').on('click', '.submit', COMMENTS.setComment);

		setInterval(COMMENTS.getComments, 60000);
		setInterval(COMMENTS.setInterval, 60000);
	},



	loadLayer: function(){
		var breakpoint = 768;

		jQuery(this).toggleClass('is-active');
		jQuery('.comments').toggleClass('is-active');

		if ( jQuery('body').width() <= breakpoint )
			jQuery(this).parent().children(':first-child').removeClass('is-blurred');
		else
			jQuery(this).parent().children(':first-child').toggleClass('is-blurred');
	},



	getComments: function(){
		COMMENTS.offset = jQuery('.comment').length;

		console.log('Comments: ' + COMMENTS.offset);
		
		
		
// 		jQuery.ajax({
//             url: kdkJS.ajaxurl,
//             type:'GET',
//             data: "action=kdk_get_comments", 
//             success: function(response){
// console.log('Hello Comments GET');
//             	var regex    = new RegExp(/[0]$/);
// 				var response = response.replace(regex, '');
//             	console.log(response);

//             	COMMENTS.commentsContent = JSON.parse(response);
// 				COMMENTS.placeCommentsContent();
//             },
//             error : function(jqXHR, textStatus, errorThrown){
//                 console.log('AJAX Error: ' + textStatus + ' ' + errorThrown);
//             }
//         });

		fetch(kdkJS.url + '/wp-json/wp/v2/comments/?post=1&order=asc&per_page=200&offset=' + COMMENTS.offset)
			.then(response => {
				// console.log(response.headers.get('x-wp-total')); 
				return response.json()
			})
			.then(data => {
				// console.log(data);
				COMMENTS.commentsContent = data;
				COMMENTS.placeCommentsContent();
			})
			.catch(err => {
				console.log('Comments Content not loaded');
				console.log(err);
		});




		// if ( offset == 0 )
		// 	COMMENTS.getComments();
	},



	placeCommentsContent: function(){
		let data = COMMENTS.commentsContent;

		data.forEach(function(v,i){
			var html = '';


			const d = new Date(v.date);
			let commentDate = 
				   ( d.getDate() >= 10 ? d.getDate() : ("0" + d.getDate())) + "." + 
				   ((d.getMonth() + 1) >= 10 ? (d.getMonth() + 1) : ("0" + (d.getMonth() + 1))) + "." +
				   d.getFullYear() + '&nbsp;&nbsp;&nbsp;' + 
				   (d.getHours() >= 10 ? d.getHours() : ("0" + d.getHours())) + ":" + 
				   (d.getMinutes() >= 10 ? d.getMinutes() : ("0" + d.getMinutes())) + ":" + 
				   (d.getSeconds() >= 10 ? d.getSeconds() : ("0" + d.getSeconds()));

			html +=  '<div class="comment comment-' + v.id + '" data-commentid="' + v.id + '" data-time="' + v.date + '">';
				html +=  '<div class="meta is-size-7">';
					html +=  '<span>' + v.author_name + '</span>';
					html +=  '<span>' + commentDate + '</span>';
				html +=  '</div>';
				html +=  v.content.rendered;
			html +=  '</div>';


			if (jQuery('.comment-list .simplebar-content').length < 1) // Mobile Support
				jQuery('.comment-list').prepend(html);
			else
				jQuery('.comment-list .simplebar-content').prepend(html);
		});

		COMMENTS.setInterval();
			// const simpleBar = new SimpleBar(document.getElementById('comment-list'));
			// simpleBar.recalculate();
		
console.log(COMMENTS.offset);
		if ( COMMENTS.offset == 0 )
			COMMENTS.getComments;

	},



	setComment: function(){
		let arrData = jQuery('#comment-form').serializeArray();
		
		objData = {};
		jQuery.each( arrData, function( index, element ) {
			objData[element.name] = element.value;
		});

		jQuery.ajax({
            url: kdkJS.url + '/wp-json/wp/v2/comments/',
            method:'POST',
            data: objData,
            beforeSend: function ( xhr ) {
        		xhr.setRequestHeader( 'X-WP-Nonce', kdkJS.nonce );
    		},
            success: function(response){
            	// console.log(response);
  				COMMENTS.getComments();
  				jQuery('#comment-form textarea').val('');
            },
            error : function(jqXHR, textStatus, errorThrown){
                console.log('AJAX Error: ' + textStatus + ' ' + errorThrown);
            }
        });
		

		return false;
	},



	setInterval: function(){
		let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

		if (isSafari)
			return;

		jQuery.each(jQuery('.comment'), function(i,v){
			let time = jQuery(v).attr('data-time');
			let diff = new Date() - new Date(time);
			let sec = diff / 1000;
			let newtime = '';

			if ( sec < 60){
				newtime = Math.round(sec) + ' Sek.';
			} else if (sec < 3600 ) {
				newtime = Math.round(sec/60) + ' Min.';
			} else if (sec < 86400){
				newtime = Math.round(sec/60/60) + ' Std.';
			} else if (sec < 864.000) { //10 Tag
				newtime = Math.round(sec/60/60/24) + ' Tage';
			} else {
				return;
			}

			jQuery('.meta i', v).text(newtime);
		});
	}
}